var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelBadgeFlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 290,
    viewBox: "0 0 579 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.539 38.2695H311.467L296.072 268.065H281.053L270.539 38.2695Z",
    fill: "url(#paint0_linear_7152_2970)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.539 483.596H311.467L296.072 253.8H281.053L270.539 483.596Z",
    fill: "url(#paint1_linear_7152_2970)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M579.002 240.477L579.002 281.404L283.87 266.009L283.87 250.99L579.002 240.477Z",
    fill: "url(#paint2_linear_7152_2970)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000978352 240.477L0.000976562 281.404L298.137 266.009L298.137 250.99L0.000978352 240.477Z",
    fill: "url(#paint3_linear_7152_2970)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M451.974 501.412L416.529 521.876L282.295 258.589L295.302 251.079L451.974 501.412Z",
    fill: "url(#paint4_linear_7152_2970)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.124 -0.00781095L110.679 20.456L273.079 270.95L286.087 263.44L146.124 -0.00781095Z",
    fill: "url(#paint5_linear_7152_2970)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M550.448 387.959L529.984 423.403L282.09 262.506L289.599 249.499L550.448 387.959Z",
    fill: "url(#paint6_linear_7152_2970)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6685 98.4746L12.2044 133.919L278.095 269.654L285.605 256.647L32.6685 98.4746Z",
    fill: "url(#paint7_linear_7152_2970)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.473 521.879L127.028 501.415L287.927 253.522L300.934 261.032L162.473 521.879Z",
    fill: "url(#paint8_linear_7152_2970)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M467.443 20.4531L431.998 -0.0107235L296.262 265.878L309.27 273.388L467.443 20.4531Z",
    fill: "url(#paint9_linear_7152_2970)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0186 423.402L28.5545 387.958L291.844 253.725L299.354 266.732L49.0186 423.402Z",
    fill: "url(#paint10_linear_7152_2970)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M565.916 133.92L545.452 98.4755L294.956 260.875L302.466 273.882L565.916 133.92Z",
    fill: "url(#paint11_linear_7152_2970)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7152_2970",
    x1: 291.003,
    y1: 38.2695,
    x2: 291.003,
    y2: 268.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7152_2970",
    x1: 291.003,
    y1: 483.596,
    x2: 291.003,
    y2: 253.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7152_2970",
    x1: 551.591,
    y1: 260.94,
    x2: 283.87,
    y2: 260.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7152_2970",
    x1: 4.13133,
    y1: 260.94,
    x2: 298.137,
    y2: 260.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7152_2970",
    x1: 420.546,
    y1: 487.906,
    x2: 286.687,
    y2: 256.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7152_2970",
    x1: 130.466,
    y1: 13.8011,
    x2: 277.467,
    y2: 268.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7152_2970",
    x1: 516.478,
    y1: 391.976,
    x2: 284.625,
    y2: 258.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7152_2970",
    x1: 26.0134,
    y1: 118.262,
    x2: 280.629,
    y2: 265.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7152_2970",
    x1: 158.456,
    y1: 487.909,
    x2: 292.315,
    y2: 256.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7152_2970",
    x1: 447.655,
    y1: 13.7982,
    x2: 300.654,
    y2: 268.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7152_2970",
    x1: 62.5248,
    y1: 391.975,
    x2: 294.378,
    y2: 258.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7152_2970",
    x1: 552.107,
    y1: 118.263,
    x2: 297.492,
    y2: 265.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelBadgeFlare);
export default __webpack_public_path__ + "static/media/LevelBadgeFlare.76dab0d618e1e5b5cb604846dc7c50ab.svg";
export { ForwardRef as ReactComponent };